import React from "react";
import { Helmet } from "react-helmet";

function RefundPolicy() {
  return (
    <>
      <Helmet>
        <title>Neralen - Ζαχαροπλαστική Τέχνη</title>
        <meta
          name="description"
          content="Neralen - Ανακαλύψτε τον κόσμο της ζαχαροπλαστικής τέχνης με αυθεντικές συνταγές και επαγγελματικές συμβουλές"
        />
      </Helmet>

      <div className="policy-container">
        <h1>Πολιτική Επιστροφών</h1>

        <p>Τελευταία ενημέρωση: 15 Ιανουαρίου 2025</p>

        <h2>1. Γενικές Πληροφορίες</h2>
        <p>
          Στο Neralen, δεσμευόμαστε να παρέχουμε περιεχόμενο υψηλής ποιότητας
          και να εξασφαλίζουμε την ικανοποίηση των αναγνωστών μας. Αυτή η
          πολιτική επιστροφών περιγράφει τους όρους και τις προϋποθέσεις υπό τις
          οποίες μπορείτε να ζητήσετε επιστροφή χρημάτων για οποιαδήποτε
          υπηρεσία πληρωμής που παρέχεται από το Neralen.
        </p>

        <h2>2. Δικαίωμα Επιστροφής</h2>
        <p>
          Εάν για οποιονδήποτε λόγο δεν είστε απόλυτα ευχαριστημένοι με μια
          υπηρεσία που έχετε αγοράσει από το Neralen, έχετε το δικαίωμα να
          ζητήσετε επιστροφή χρημάτων εντός 14 ημερολογιακών ημερών από την
          ημερομηνία αγοράς.
        </p>

        <h2>3. Προϋποθέσεις Επιστροφής</h2>
        <p>
          Για να δικαιούστε επιστροφή χρημάτων, πρέπει να πληρούνται οι
          ακόλουθες προϋποθέσεις:
        </p>

        <ul>
          <li>
            Το αίτημα επιστροφής πρέπει να υποβληθεί εντός 14 ημερών από την
            αγορά
          </li>
          <li>Πρέπει να παρέχετε απόδειξη αγοράς</li>
          <li>Πρέπει να εξηγήσετε τον λόγο της επιστροφής</li>
          <li>
            Η υπηρεσία δεν πρέπει να έχει χρησιμοποιηθεί πλήρως ή εκτεταμένα
          </li>
        </ul>

        <h2>4. Διαδικασία Επιστροφής</h2>
        <p>
          Για να ξεκινήσετε μια επιστροφή, παρακαλούμε ακολουθήστε τα παρακάτω
          βήματα:
        </p>

        <ol>
          <li>
            Επικοινωνήστε μαζί μας μέσω email στο{" "}
            <a href="mailto:neralen@hotmail.com">neralen@hotmail.com</a>
          </li>
          <li>
            Συμπεριλάβετε τον αριθμό παραγγελίας σας και τον λόγο επιστροφής
          </li>
          <li>
            Αναμένετε την επιβεβαίωση από την ομάδα μας εντός 2-3 εργάσιμων
            ημερών
          </li>
          <li>
            Αφού εγκριθεί το αίτημά σας, η επιστροφή χρημάτων θα πραγματοποιηθεί
            εντός 5-10 εργάσιμων ημερών
          </li>
        </ol>

        <h2>5. Μέθοδοι Επιστροφής Χρημάτων</h2>
        <p>
          Οι επιστροφές χρημάτων θα πραγματοποιούνται χρησιμοποιώντας την ίδια
          μέθοδο πληρωμής που χρησιμοποιήθηκε για την αρχική συναλλαγή, εκτός
          εάν συμφωνηθεί ρητά διαφορετικά. Δεν θα χρεωθείτε για την επιστροφή
          χρημάτων.
        </p>

        <h2>6. Εξαιρέσεις</h2>
        <p>
          Ορισμένες περιπτώσεις δεν καλύπτονται από την πολιτική επιστροφών μας:
        </p>

        <ul>
          <li>
            Ψηφιακό περιεχόμενο που έχει παραδοθεί και χρησιμοποιηθεί πλήρως
          </li>
          <li>
            Υπηρεσίες που έχουν ολοκληρωθεί πλήρως με τη ρητή συγκατάθεσή σας
          </li>
          <li>Προσαρμοσμένες ή εξατομικευμένες υπηρεσίες</li>
          <li>
            Αιτήματα επιστροφής που υποβάλλονται μετά την περίοδο των 14 ημερών
          </li>
        </ul>

        <h2>7. Μερική Επιστροφή</h2>
        <p>
          Σε ορισμένες περιπτώσεις, μπορεί να εγκριθεί μόνο μερική επιστροφή
          χρημάτων. Αυτό μπορεί να συμβεί σε περιπτώσεις όπου η υπηρεσία έχει
          χρησιμοποιηθεί εν μέρει ή εάν υπάρχει απόδειξη σημαντικής χρήσης.
        </p>

        <h2>8. Καθυστερήσεις Επιστροφής</h2>
        <p>
          Εάν δεν έχετε λάβει την επιστροφή χρημάτων σας εντός του αναμενόμενου
          χρονικού πλαισίου, παρακαλούμε:
        </p>

        <ul>
          <li>Ελέγξτε ξανά τον τραπεζικό σας λογαριασμό</li>
          <li>Επικοινωνήστε με την εταιρεία της πιστωτικής σας κάρτας</li>
          <li>Επικοινωνήστε με την τράπεζά σας</li>
          <li>
            Εάν έχετε κάνει όλα αυτά και δεν έχετε λάβει ακόμη την επιστροφή
            χρημάτων, επικοινωνήστε μαζί μας στο{" "}
            <a href="mailto:neralen@hotmail.com">neralen@hotmail.com</a>
          </li>
        </ul>

        <h2>9. Ακυρώσεις</h2>
        <p>
          Μπορείτε να ακυρώσετε την παραγγελία σας οποιαδήποτε στιγμή πριν από
          την παράδοση ή την ολοκλήρωση της υπηρεσίας. Οι ακυρώσεις που γίνονται
          εντός 24 ωρών από την αγορά είναι επιλέξιμες για πλήρη επιστροφή
          χρημάτων.
        </p>

        <h2>10. Αλλαγές στην Πολιτική</h2>
        <p>
          Η Neralen διατηρεί το δικαίωμα να τροποποιήσει αυτήν την πολιτική
          επιστροφών ανά πάσα στιγμή. Οι αλλαγές θα τίθενται σε ισχύ αμέσως μετά
          τη δημοσίευσή τους στον ιστότοπο. Η συνεχιζόμενη χρήση των υπηρεσιών
          μας μετά από τέτοιες αλλαγές συνιστά αποδοχή της νέας πολιτικής
          επιστροφών.
        </p>

        <h2>11. Επικοινωνία</h2>
        <p>
          Για οποιεσδήποτε ερωτήσεις σχετικά με την πολιτική επιστροφών μας ή
          για να ξεκινήσετε μια επιστροφή, επικοινωνήστε μαζί μας:
        </p>

        <ul>
          <li>
            Email: <a href="mailto:neralen@hotmail.com">neralen@hotmail.com</a>
          </li>
          <li>Τηλέφωνο: +302130281863</li>
          <li>
            Διεύθυνση: Armatolon ke Klefton 48, 114 71, Αμπελόκηποι, Greece
          </li>
          <li>ΑΦΜ: 23031216</li>
        </ul>

        <h2>12. Εξυπηρέτηση Πελατών</h2>
        <p>
          Η ομάδα εξυπηρέτησης πελατών μας είναι διαθέσιμη να σας βοηθήσει με
          οποιεσδήποτε ερωτήσεις ή ανησυχίες σχετικά με την πολιτική επιστροφών.
          Είμαστε αφοσιωμένοι στο να εξασφαλίσουμε την ικανοποίησή σας και θα
          καταβάλλουμε κάθε προσπάθεια να επιλύσουμε τυχόν προβλήματα γρήγορα
          και δίκαια.
        </p>
      </div>
    </>
  );
}

export default RefundPolicy;
